// Claves de query centralizadas para el dominio timeentry.
// Siguen jerarquía para poder invalidar en distintos niveles de granularidad.

export const timeEntryKeys = {
  all: ["timeentry"] as const,

  /** Horas faltantes del colaborador. */
  missingHours: () => [...timeEntryKeys.all, "missing-hours"] as const,

  /** Resumen mensual de horas por proyecto. */
  monthlySummary: () => [...timeEntryKeys.all, "monthly-summary"] as const,

  /** Proyectos con asignaciones (usados en selectores y localStorage). */
  projectsWithAssignments: () => [...timeEntryKeys.all, "projects-with-assignments"] as const,

  /** Proyectos con asignaciones Jira. */
  projectsWithAssignmentsJira: () =>
    [...timeEntryKeys.all, "projects-with-assignments-jira"] as const,

  /** Catálogo de actividades de imputación. */
  activities: () => [...timeEntryKeys.all, "activities"] as const,

  /** Proyectos asignados (estructura / estructura operativa). */
  assignedProjects: () => [...timeEntryKeys.all, "assigned-projects"] as const,

  /**
   * Issues de un proyecto Redmine (distingue por projectId). Acepta `undefined`
   * porque los dialogs llaman a este factory antes de que el usuario elija
   * proyecto (`watch("projectId")` empieza vacío) — el hook desactiva la query
   * en ese caso, pero la key igual se computa para el cache de TanStack.
   */
  projectIssues: (projectId: number | string | undefined) =>
    [...timeEntryKeys.all, "issues", projectId] as const,

  /** Issues de un proyecto Jira (distingue por projectId). Ídem `projectIssues`. */
  projectIssuesJira: (projectId: number | string | undefined) =>
    [...timeEntryKeys.all, "issues-jira", projectId] as const,
} as const;
